module.exports = __webpack_public_path__ + "static/media/globo-compuerta-06.59ee618d.png";